import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import LangA from '../../../i18n/LangA';

const FooterLinksGroup = ({ title, children, alt, titleId }) => {
  const [isActive, setIsActive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1024);
  };

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const childItems = children.props.children;

  return (
    <div className={cx('footer-links-group', { 'is-active': isActive })}>
      {childItems && childItems.length > 1 ? (
        <h3 className="h6">
          {isMobile ? (
            <button id={'mobile_' + titleId} className="cursor-default-lg" type="button" onClick={() => setIsActive(!isActive)}>
              {title}

              <i className="ico-svg-angle-down">
                <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
                  <g transform="translate(-364 -438)" fill="none" fillRule="evenodd">
                    <path fill="#171E25" d="M376.013 438L371 443.022 365.987 438l-1.487 1.49L371 446l6.5-6.51z" />
                  </g>
                </svg>
              </i>
            </button>
          ) : (
            title
          )}
        </h3>
      ) : (
        <h3 id={titleId} className="h6">
          <LangA href={childItems[0].props.href} title={alt}>
            {title}
          </LangA>
        </h3>
      )}

      {childItems && childItems.length > 1 && <div className="footer-links-group__items">{children}</div>}
    </div>
  );
};

export default FooterLinksGroup;
